import Cover from "../../book/cover";
import { TextEllipsis } from "../../../../components/text-ellipsis";
import { PluralTranslation } from "../../../../core/translate";
import React from "react";
import { Card } from "@vitalsource/vstui";
import styled from "styled-components";
import { cloud } from "@vitalsource/vstui/colors";

export const RESULT_WIDTH = 244;
export const SHADOW_PADDING = 2;

const OuterButton = styled.button`
  background: none;
  border: none;
  text-align: left;
  margin: 0;
  padding: ${SHADOW_PADDING}px;
  display: block;
`;

const CardInner = styled.div`
  width: ${RESULT_WIDTH - SHADOW_PADDING * 2}px;
  height: 126px;
  padding: 11px 14px;
  font-size: 1.6rem;
`;

const BookInfoWrapper = styled.div`
  height: 72px;
  overflow: hidden;
  color: ${cloud.getShade(10)};
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
`;

const CoverWrapper = styled.div`
  min-width: 44px;
  margin-right: 12px;
  border-radius: 2px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  align-self: flex-start;
  overflow: hidden;
`;

const ResultCount = styled.div`
  border-top: 1px solid ${cloud.getShade(4)};
  text-align: center;
  padding-top: 9px;
  color: ${props => props.theme.color.primary.getShade(7)};
`;

const TitleWrapper = styled.div`
  padding-top: 11px;
`;

export default class ResultCard extends React.Component {
  state = {
    everShown: false
  };

  UNSAFE_componentWillReceiveProps(nextProps, prevState) {
    if (nextProps.fullRender && !prevState.everShown) {
      this.setState({
        everShown: true
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      this.state.everShown !== nextState.everShown ||
      (!!this.props.book.isLoading && !nextProps.book.isLoading)
    );
  }

  handleClick = () => {
    this.props.onClick(this.props.book);
  };

  render() {
    const { book } = this.props;

    if (book.isLoading) {
      return (
        <Card>
          <CardInner>Loading...</CardInner>
        </Card>
      );
    }

    if (!this.props.fullRender) {
      return (
        <OuterButton type="button" onClick={this.handleClick}>
          <Card raised interactive>
            <CardInner>{book.title.decodeHTML()}</CardInner>
          </Card>
        </OuterButton>
      );
    }

    return (
      <OuterButton type="button" onClick={this.handleClick}>
        <Card raised interactive>
          <CardInner>
            <BookInfoWrapper>
              <CoverWrapper>
                <Cover
                  isbn={book.isbn}
                  width={44}
                  height={60}
                  includeRetina={false}
                  bookTitle={book.title}
                />
              </CoverWrapper>
              <TitleWrapper>
                <TextEllipsis toolTipText={book.title.decodeHTML()} lines={2}>
                  <div>{book.title.decodeHTML()}</div>
                </TextEllipsis>
              </TitleWrapper>
            </BookInfoWrapper>
            <ResultCount>
              <PluralTranslation
                singular="filter.result"
                plural="filter.results"
                count={book.count}
                amount={book.count}
              />
            </ResultCount>
          </CardInner>
        </Card>
      </OuterButton>
    );
  }
}
